import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { CartItemListComponent } from '@spartacus/cart/base/components';
import { OrderEntry } from '@spartacus/cart/base/root';

@Component({
  selector: 'custom-cx-cart-item-list',
  templateUrl: './cart-item-list.component.html',
  styleUrl: './cart-item-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomCartItemListComponent extends CartItemListComponent implements OnInit {
  @Input() isOrder = false;
  @Input() displayDates = true;
  @Input() displayValues = true;

  convertQty(data: any): UntypedFormControl {
    return data;
  }

  parseOrderEntry(item: OrderEntry): OrderEntry {
    return {
      ...item,
      ...{},
    };
  }
}
